<!--
USAGE:
<b-data-table
                    :headers="headers"
                    :items="customers"
                    :page="paginator.currentPage"
                    :options.sync="dataTableOptions"
                    :items-per-page="paginator.perPage"
                    :expanded.sync="expanded"
                    single-expand
                    :loading="loading"
                    :disable-sort="false"
                    show-expand
                    :server-items-length="paginator.total"
                >
-->
<script>
import {debounce, isEqual} from "lodash";

export default {
    data() {
        return {
            loading: false,
            defaultSortBy: {},
            defaultFilters: {},
            filters: {},
            sortBy: {},
            paginator: {
                currentPage: null,
                lastPage: null,
                perPage: null,
                total: null,
            },
            dataTableOptions: {}
        }
    },
    watch: {
        dataTableOptions(value, oldValue) {
            if (isEqual(value, oldValue)) {
                return;
            }

            this.paginator.currentPage = value.page;
            this.sortBy = this.formatSortBy(value.sortBy, value.sortDesc);

            this.search();
        },
        filters: {
            handler: debounce(function() {
                this.search();
            }, 300),
            deep: true,
        },
    },
    methods: {
        formatSortBy(columns = [], desc = []) {
            let sortBy = {};
            columns.forEach((column, index)=> {
                sortBy[column] = desc[index] ? 'desc' : 'asc';
            });

            return sortBy;
        },
        resetFilters() {
            this.filters = Object.assign({}, this.defaultFilters);
            this.sortBy = Object.assign({}, this.defaultSortBy);
        },
    },
    created() {
        this.resetFilters();
    }
}
</script>
